<template>
    <el-row>
        <el-col :span="24">
            <el-card shadow="never">
                <h2 class="text-left">All Customer</h2>
                <el-row>
                    <all-customer-table></all-customer-table>
                </el-row>
            </el-card>
        </el-col>
    </el-row>
</template>

<script>
import AllCustomerTable from '@/components/Customer/AllCustomer/AllCustomerTable'
export default {
    name: 'allCustomer',
    components: {
        AllCustomerTable
    },
    data () {
        return {}
    }
}
</script>
